import axios, { AxiosError, AxiosResponse } from "axios";

const instance = axios.create({
    baseURL: "/umbraco/api/",
});

const handleError = (error: AxiosError) => {
    if (error.response) {
        return Promise.reject(error.response.data);
    }
        return Promise.reject(error);
};

instance.interceptors.request.use((config) => {
    const culture = document.querySelector("html")!.getAttribute("lang");
    const contentId = document.querySelector("html")!.getAttribute("content-id");
    Object.assign(config.headers, {
        "X-Requested-With": "XMLHttpRequest",
        "X-Content-Id": contentId,
        "Accept-Language": culture,
    });
    return config;
}, handleError);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance.interceptors.response.use((response: AxiosResponse<any>) => {
    return response.data;
}, handleError);

export default instance;
